export default {
  //url: 'http://163.172.177.145:8080/api'
  url: 'https://api.testspell.com/api'
  //url: 'https://localhost/api'
};


// WEBPACK FOOTER //
// ./src/containers/App/backend.js